import { useEffect, useState } from "react";
import { WifiOff, RefreshCw, Download } from "lucide-react";
import { useOnline } from "@/hooks/useOnline";
import { onQueueChange, pendingCount } from "@/lib/offlineSync";

export const OfflineBadge = () => {
  const online = useOnline();
  const [pending, setPending] = useState(0);
  useEffect(() => {
    pendingCount().then(setPending);
    return onQueueChange(setPending);
  }, []);
  if (online && !pending) return null;
  return (
    <span data-testid="offline-badge" className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold ${online ? "bg-blue-50 text-blue-700" : "bg-slate-900 text-white"}`}>
      {online ? <RefreshCw size={14} className="animate-spin" /> : <WifiOff size={14} />}
      <span className="hidden sm:inline">{online ? `Syncing ${pending}` : pending ? `Offline · ${pending} to sync` : "Offline"}</span>
    </span>
  );
};

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new Event("lp-installable"));
});

export const InstallButton = () => {
  const [ready, setReady] = useState(!!deferredPrompt);
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("lp-installable", on);
    return () => window.removeEventListener("lp-installable", on);
  }, []);
  if (!ready) return null;
  return (
    <button
      data-testid="install-app-button"
      onClick={async () => {
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
        deferredPrompt = null;
        setReady(false);
      }}
      className="hidden sm:flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))]"
    >
      <Download size={14} /> Install app
    </button>
  );
};
